import * as devisConf from '@/configuration/devisConf';

function moveItem(data, from, to) {
  const f = data.splice(from, 1)[0];
  let realTo = to;
  if (from < to) {
    // comme j'enleve d'abord mon tableau est moins grand
    realTo -= 1;
  }
  data.splice(realTo, 0, f);
}

export default function reordonnancementRegroupementPersonnalise(lignesCommande) {
  const listeReseauPerso = lignesCommande.filter(ligne => ligne.type === devisConf.PERSONNALISE);
  listeReseauPerso.forEach(groupe => {
    let indexGroupe = lignesCommande.indexOf(groupe);
    const contenuRP = lignesCommande
      .filter(ligne => ligne.type !== devisConf.PERSONNALISE
                       && ligne.referencePersonnalise === groupe.referencePersonnalise)
      .sort((a, b) => a.ordre - b.ordre);
    contenuRP.forEach(sousLigne => {
      const indexSSLigne = lignesCommande.indexOf(sousLigne);
      if (indexSSLigne !== indexGroupe + 1) {
        moveItem(lignesCommande, indexSSLigne, indexGroupe + 1);
      }
      indexGroupe += 1;
    });
  });
}
